import React, { useContext, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import "react-circular-progressbar/dist/styles.css";
import "swiper/swiper-bundle.css";
import CanvasJSReact from "@canvasjs/react-charts";
import { Context } from "../../../utils/context";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Accordion from "react-bootstrap/Accordion";
import {
  faCartShopping,
  faBoxOpen,
  faUsers,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { Chart } from "react-google-charts";
import DataTable from "datatables.net";
import Button from "react-bootstrap/Button";
import { Link, useLocation } from "react-router-dom";
import { Table } from "react-bootstrap";
import Cookies from "js-cookie";
import search1 from "../../../Components/assets/icons/search.png";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

library.add(fas);

const AdvanceDashboard = () => {
  const { getData, userdata, user, usertype } = useContext(Context);

  const [result, setResult] = useState({});
  const getDataAll = async () => {
    const result = await getData("/dashboard");
    setResult(result.data);
  };
  // console.log(result);
  useEffect(() => {
    // getDataAll();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      Cookies.set("coinzkart_admin_security", token, {
        expires: 1,
      });
    }
  }, []);

  // search functionality start

  const [filter, setFilter] = useState("");

  const handleFilterChange = (event) => {
    setFilter(event.target.value.toLowerCase());
  };

  const [countOrders, setCountOrders] = useState("");
  const GetEditData = async () => {
    const res = await getData(`/count-all-orders`);
    setCountOrders(res?.data?.count);
  };
  const [countProducts, setCountProducts] = useState("");
  const GetProductData = async () => {
    const res = await getData(`/count-all-products`);
    setCountProducts(res?.data);
  };
  const [countCustomers, setCountCustomers] = useState("");
  const GetCustomersData = async () => {
    const res = await getData(`/count-all-customers`);
    setCountCustomers(res?.data?.count);
  };
  const [countSellers, setCountSellers] = useState("");
  const GetSellersData = async () => {
    const res = await getData(`/count-all-sellers`);
    setCountSellers(res?.data?.count);
  };
  useEffect(() => {
    GetEditData();
    GetProductData();
    GetCustomersData();
    GetSellersData();
  }, []);

  const cardsData = [
    {
      number: countOrders,
      types: "Orders",
      icon: "fa-cart-shopping",
      className: "#63bff5",
      api: "/order-managements/order",
    },
    {
      number: countProducts?.count,
      types: "Corporate Products",
      icon: "fa-solid fa-boxes-stacked",
      className: "#63bff5",
      api: "/product",
    },
    {
      number: countProducts?.luxury_count,
      types: "Luxury Products",
      icon: "fa-solid fa-boxes-stacked",
      className: "#63bff5",
      api: "/luxury-product",
    },
    {
      number: countCustomers,
      types: "Customers",
      icon: "fa-solid fa-users",
      className: "#63bff5",
      api: "/employee/customer-details",
    },
    {
      number: countSellers,
      types: "Sellers",
      icon: "fa-solid fa-users",
      className: "#63bff5",
      api: "/seller-detail",
    },
  ];

  const cardsSellerData = [
    {
      number: countOrders,
      types: "Orders",
      icon: "fa-cart-shopping",
      className: "#63bff5",
      api: "/order-managements/order",
    },
    {
      number: countProducts?.count,
      types: "Corporate Products",
      icon: "fa-solid fa-boxes-stacked",
      className: "#63bff5",
      api: "/product",
    },
    {
      number: countProducts?.luxury_count,
      types: "Luxury Products",
      icon: "fa-solid fa-boxes-stacked",
      className: "#63bff5",
      api: "/luxury-product",
    },
  ];

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  useEffect(() => {
    const table = new DataTable("#exampleContent");
    return () => {
      table.destroy();
    };
  }, []);

  const colors = ["#63bff5", "#f39c12", "#dd4b39", "#00a65a"];
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [singleVarient, setsingleVarient] = useState("");
  const [onPageChange, setonPageChange] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(20);
  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };
  const [inventoryProduct, setInventoryProduct] = useState("");
  const GetInventoryProduct = async () => {
    const res = await getData(
      `/all-stock-product?term=${search||""}&singleVarient=${
        singleVarient?.value || ""
      }&page=${onPageChange}&per_page=${perPage}`,
    );
    await setInventoryProduct(res?.data);
    settotalPages(res?.data.totalPages);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setSearch(res?.search_name);
  };
  useEffect(() => {
    GetInventoryProduct();
  }, [reset, onPageChange]);

  return (
    <div className="main-advancedashboard">
      <section className="AdvanceDashboard">
        <div className="AdvanceDashboardTabs">
          <Header title={"Dashboard"} link={"/masters/social_links"} />
          <div className=""></div>
        </div>
      </section>
      <div className="Main-Section-Advanced-Dashboard">
        <h1 className="title">Home</h1>
        <Row className="gy-4">
          {usertype === "Admin"
            ? cardsData.map((item, index) => (
                <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} key={index}>
                  <Card
                    className="small-box"
                    style={{ backgroundColor: colors[index % colors.length] }}
                  >
                    <div className={item.className}>
                      <div className="content">
                        <div className="inner">
                          <h3>{item.number}</h3>
                          <p>{item.types}</p>
                        </div>
                        <div className="icon">
                          <FontAwesomeIcon icon={item.icon} />
                        </div>
                      </div>
                      <Link to={item?.api}>
                        <p className="mb-0 small-box-footer">
                          More info{" "}
                          <FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" />
                        </p>
                      </Link>
                    </div>
                  </Card>
                </Col>
              ))
            : cardsSellerData.map((item, index) => (
                <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} key={index}>
                  <Card
                    className="small-box"
                    style={{ backgroundColor: colors[index % colors.length] }}
                  >
                    <div className={item.className}>
                      <div className="content">
                        <div className="inner">
                          <h3>{item.number}</h3>
                          <p>{item.types}</p>
                        </div>
                        <div className="icon">
                          <FontAwesomeIcon icon={item.icon} />
                        </div>
                      </div>
                      <Link to={item?.api}>
                        <p className="mb-0 small-box-footer">
                          More info{" "}
                          <FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" />
                        </p>
                      </Link>
                    </div>
                  </Card>
                </Col>
              ))}
        </Row>

        <div className="row me-0 ms-0 mt- data-table-holder">
          <div className="col-md-12">
            <h5>
              <b>Stock Inventory</b>
            </h5>
            <div className="search-holder">
              <div className="row">
                <div className="col-xxl-3 col-xl-2  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-3">
                  <div className="num me-2">
                    <input
                      type="text"
                      className="form-control"
                      id=""
                      placeholder="product"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-6 col-12 mt-md-0 mt-3 mb-3">
                  <div className="Search me-2">
                    <Button
                      type="button"
                      onClick={GetInventoryProduct}
                      className="btn btn-search"
                    >
                      Search
                    </Button>
                  </div>
                </div>
                <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-6 col-12 mt-md-0 mt-3 mb-3">
                  <div className="Search-1 me-2">
                    <button
                      type="button"
                      onClick={() => {
                        setSearch("");
                        setsingleVarient("");
                        setReset(!reset);
                      }}
                      className="btn btn-reset btn-danger"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <div className="data table-responsive">
              <Table striped bordered hover responsive center>
                <thead>
                  <tr>
                    <th className="sr">Sr. No.</th>
                    <th className="tax-name">Product</th>
                    <th className="tax-name">Variant</th>
                    <th className="tax-name">Sub Variant</th>
                    <th className="tax-name">Stock</th>
                    <th className="tax-name">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {inventoryProduct?.data?.length > 0 ? (
                    inventoryProduct?.data?.map((d, index) => {
                      // calculate total rows for this product
                      const totalRows = d?.product_variants?.reduce(
                        (sum, variant) => {
                          return (
                            sum +
                            (variant?.product_quantities?.length > 0
                              ? variant.product_quantities.length
                              : 1)
                          );
                        },
                        0,
                      );

                      let isFirstRow = true;

                      return d?.product_variants?.map((variant) =>
                        variant?.product_quantities?.length > 0
                          ? variant.product_quantities.map((qty) => {
                              const row = (
                                <tr key={qty.id}>
                                  {isFirstRow && (
                                    <>
                                      <td rowSpan={totalRows}>{index + 1}</td>
                                      <td rowSpan={totalRows}>{d?.name}</td>
                                    </>
                                  )}

                                  <td>{variant?.v_name}</td>
                                  <td>{qty?.name}</td>
                                  <td>{qty?.unit}</td>

                                  <td
                                    style={{
                                      color:
                                        qty?.unit <= 0
                                          ? "red"
                                          : qty?.unit < 10
                                            ? "orange"
                                            : "green",
                                    }}
                                  >
                                    {qty?.unit <= 0
                                      ? "Out of stock"
                                      : qty?.unit < 10
                                        ? "Low in stock"
                                        : "In stock"}
                                  </td>
                                </tr>
                              );

                              isFirstRow = false;
                              return row;
                            })
                          : (() => {
                              const row = (
                                <tr key={variant.id}>
                                  {isFirstRow && (
                                    <>
                                      <td rowSpan={totalRows}>{index + 1}</td>
                                      <td rowSpan={totalRows}>{d?.name}</td>
                                    </>
                                  )}

                                  <td>{variant?.v_name}</td>
                                  <td>N/A</td>
                                  <td>{variant?.unit}</td>

                                  <td
                                    style={{
                                      color:
                                        variant?.unit <= 0
                                          ? "red"
                                          : variant?.unit < 10
                                            ? "orange"
                                            : "green",
                                    }}
                                  >
                                    {variant?.unit <= 0
                                      ? "Out of stock"
                                      : variant?.unit < 10
                                        ? "Low in stock"
                                        : "In stock"}
                                  </td>
                                </tr>
                              );

                              isFirstRow = false;
                              return row;
                            })(),
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                  <Pagination_Holder
                    onPageChange={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                  />
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvanceDashboard;
